export function discountMatchesPickerCategory(
  discountCategory: string | undefined,
  options: { includeCategories?: readonly string[] },
): boolean {
  if (!discountCategory) {
    return true;
  }
  return options.includeCategories?.includes(discountCategory) ?? false;
}
